<template>
  <div id="dashboard">
    <!-- <Breadcrumb :list="list"/> -->
    <div data-html2canvas-ignore="true" v-show="loader || loader1 || loader2 || loader3">
      <Loader />
    </div>
    <div class="card datepickerwrap" style="flex-direction: row">
      <div class="wrapitem" style="width: 100%; display: flex; flex-direction: row">
        <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between;">
          <div style="width: 60%">
            <datecomponent ref="datecomponent"> </datecomponent>
            <div class="datebox submit">
              <button @click="refresh" class="btn primarycolor" type="button">
                <span>Submit</span>
              </button>
            </div>
          </div>
          <!-- <div class="mr-2 ml-5">
            <button class="btn primarycolor" @click="createPdf">Download</button>
          </div> -->
          <div style="display: flex; gap: 8px; justify-content: flex-end; width: 25%;">
            <div class="customSelect w-100">
              <p class="channel-title">Channel:</p>
              <select @change="processCategory" v-model="channelSelector" class="form-control text-uppercase">
                <option :value="website.platform_name" v-for="website of viewPlatformAndCategoryData.platform"
                  :key="website.platform_name">
                  {{ website.platform_name }}
                </option>
              </select>
            </div>
            <div class="customSelect w-100">
              <select @change="icChanged" v-model="selectedItemCategory" class="form-control text-uppercase">
                <option v-for="d in itemCategory" :value="d" :key="d.key">
                  {{ d.value }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="dashboardPdf">
      <!-- <h3 class="cust-head">Total Reviews</h3> 
      -->

      <div v-if="products.length">
        <div class="d-flex datepickerwrap" style="margin-right: 0 !important; padding-bottom: 0px">
          <div class="separated-card w-100" v-for="(ud, i) in products" :key="i">
            <div class="card separated-card w-100 mb-0 pb-1">
              <div style="color: var(--primary_brand);" class="mb-1 text-capitalize">{{ selectedBrand[i] }}</div>
              <div data-html2canvas-ignore="true" class="customSelect mb-1">
                <select @change="changeProduct(ud, i, $event)" v-model="selectedProducts[i]"
                  class="form-control customSelect text-uppercase" style="margin-bottom: -10px">
                  <optgroup v-for="d in primaryProductsOptions[i]" :key="d.optgroup+i" :label="d.optgroup">
                    <option v-for="option in d.options" :value="option" :key="d.optgroup + option + i">
                      {{ option }}
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="datepickerwrap" style="margin-right: 0 !important">
          <h5 class="positive-head" style="margin-top: 2px !important">
            Reviews and Rating
          </h5>
          <div class="datepickerwrap d-flex ml-0 mr-0 pr-0 mb-0 pb-0"
            style="margin-top: -5px !important; margin-right: 0 !important" v-if="products.length">
            <div class="card separated-card w-100 mb-0" :key="idx" v-for="(ud, idx) in products">
              <div>
                <div style="margin: 10px; height: 100%">
                  <div class="space-between-header" style="border: none !important"></div>
                  <div class="pb-0 d-flex justify-content-around align-items-center mb-3 mt-2">
                    <div class="d-flex flex-column align-items-center" style="
                        border-right: 0.13rem solid #e1e1e1 !important;
                        padding-right: 16%;
                      ">
                      <h4 class="mb-0" style="color: var(--green); font-size: 2rem; font-weight: 600">
                        <span>{{ reviewCountMapper[idx][selectedProducts[idx]] | format }}</span>
                      </h4>
                      <p class="text-capitalize" style="color: var(--primary_brand); font-size: 1rem">
                        Total Reviews
                      </p>
                    </div>
                    <div class="d-flex flex-column align-items-center">
                      <h4 class="mb-0" style="color: var(--green); font-size: 2rem; font-weight: 600">
                        <span v-if="recentRating[ud.product_name] &&
                recentRating[ud.product_name].recent_rating
                " style="float: right">
                          {{ recentRating[ud.product_name].recent_rating }}&nbsp;
                        </span>
                        <span class="float-right" v-if="!loader1">{{
                ratingMapper[idx][selectedProducts[idx]].review_avg | format
              }}</span>
                      </h4>
                      <p class="text-capitalize" style="color: var(--primary_brand); font-size: 1rem">
                        Total Ratings
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="ratingMapper[idx][selectedProducts[idx]]">
                <h5 class="text-capitalize mb-2">
                  <span style="
                      max-width: 82%;
                      display: inline-block;
                      color: var(--primary_brand);
                    ">
                  </span>
                </h5>
                <div class="progress-group" v-for="r in ratingMapper[idx][selectedProducts[idx]].ratings">
                  <div class="progress-group-header">
                    <i class="fa fa-star text-star-color" v-for="s in r.rating"></i>
                    <span class="ml-auto">
                      {{ r.count | format }}
                      <span class="text-muted small">({{ r.per | format }}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <div class="progress progress-xs">
                      <div role="progressbar" class="progress-bar"
                        style="background-color: var(--green-80); border-radius: 1rem" :class="'card_' + ud.brand_name"
                        :style="'width:' + r.per + '%'"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <h3 class="cust-head">Ratings</h3> -->
        <div class="card datepickerwrap">
          <b-row>
            <b-col sm="5">
              <h5 id="traffic" class="card-title mb-0">Number of reviews</h5>
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
                  v-model="selected" name="radiosBtn">
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <highcharts :options="charts.review_count" v-if="activeChart"></highcharts>
          <div v-if="!activeChart">No Data</div>
        </div>
        <div class="card datepickerwrap">
          <b-row>
            <b-col sm="5">
              <h5 id="traffic" class="card-title mb-0">Average review rank</h5>
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons button-variant="outline-secondary"
                  v-model="selected" name="radiosBtn">
                  <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                  <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <!--highchart-->
          <highcharts :options="charts.rating" v-if="activeChart"></highcharts>
          <div v-if="!activeChart">No Data</div>
        </div>
        <div class="card datepickerwrap">
          <h3 class="card-title">Voice of Customers</h3>
          <b-row>
            <b-col sm="5" style="border-right: 1px solid #e1e1e1">
              <highcharts v-if="data.length" :options="charts.circlular" />
              <div v-if="!data.length">No data</div>
            </b-col>
            <b-col sm="7">
              <highcharts v-if="data.length" :options="charts.stackgraph" />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardLine1ChartExample from ".././dashboard/CardLine1ChartExample";
import CardLine2ChartExample from ".././dashboard/CardLine2ChartExample";
import CardLine3ChartExample from ".././dashboard/CardLine3ChartExample";
import CardBarChartExample from ".././dashboard/CardBarChartExample";
import SocialBoxChartExample from ".././dashboard/SocialBoxChartExample";
import CalloutChartExample from ".././dashboard/CalloutChartExample";
import { Callout } from "@coreui/vue";
import moment from "moment";
import datecomponent from "./DateMotherCare.vue";
import Loader from "../Components/Loader.vue";

export default {
  name: "dashboard",
  components: {
    Loader,
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    datecomponent,
  },

  data: function () {
    return {
      promises: [],
      selected: "month",
      data: [],
      userData: JSON.parse(localStorage.getItem("reviewUserData")),
      customData: JSON.parse(localStorage.getItem("reviewCustomData")),
      products: [],
      nonPrimaryProductsOptions: [],
      primaryProductsOptions: [],
      selectedProducts: [],
      reviewCountMapper: {},
      ratingMapper: {},
      dateDropDown: "custom",
      credits: false,
      loader: false,
      loader1: false,
      loader2: false,
      loader3: false,
      channelSelector: "",
      activeChart: false,
      charts: {
        circlular: {},
        stackgraph: {},
      },
      date: {},
      itemCategory: [],
      selectedItemCategory: {},
      productList: {},
      competitorData: {},
      recentRating: {},
      customClient: JSON.parse(localStorage.reviewUserData).data.client,
      viewPlatformAndCategoryData: JSON.parse(localStorage.viewPlatformAndCategoryData),
      selectedBrand: [null, null, null],
      allProducts: [],
    };
  },
  watch: {
    selected: function () {
      this.getChartData();
    },
  },
  mounted() {
    if (localStorage.demo_voc_channelSelector)
      this.channelSelector = localStorage.demo_voc_channelSelector;
    else
      this.channelSelector = this.viewPlatformAndCategoryData.platform[0].platform_name;
    this.processCategory();
    // this.getCompetitorSet();
  },
  methods: {
    /* Not needed as we are not comparing the brands */
    getCompetitorSet() {
      let self = this;
      let url = "/api/indian_clients/product_set_list_compare";
      let payload = {
        client: self.customClient,
      };
      this.$http.post(url, payload).then(
        (response) => {
          self.competitorData = response.body.data.voc_product_list;
        },
        (err) => {
        }
      );
    },
    getProductsList() {
      this.loader = true;
      const url = "/api/global_demo/multi/new_products_list";
      const payload = {
        channel: this.channelSelector,
        item_category: this.selectedItemCategory.key,
        client: this.customClient,
        max_products: 0
      }

      this.$http.post(url, payload).then((response) => {
        this.allProducts = response.body.data;
        this.init();
        this.loader = false;
      },
        (err) => {
          this.loader = false;
        })
    },
    processCategory() {
      localStorage.demo_voc_channelSelector = this.channelSelector;
      this.itemCategory = [];
      if (localStorage.demo_voc_product_list)
        this.productList = JSON.parse(localStorage.demo_voc_product_list);
      for (let [i, k] of Object.keys(this.productList[this.channelSelector]).entries()) {
        this.itemCategory.push({ key: k, value: k.replace("_", " ") });
      }
      if (localStorage.demo_selectedItemCategory) {
        this.selectedItemCategory = {};
        for (let [i, k] of this.itemCategory.entries()) {
          if (k.key == JSON.parse(localStorage.demo_selectedItemCategory).key) {
            this.selectedItemCategory = k;
          }
        }
        if (!Object.keys(this.selectedItemCategory).length) {
          this.selectedItemCategory = this.itemCategory[0];
        }
      } else {
        this.selectedItemCategory = this.itemCategory[0];
      }
      this.getProductsList();
      // this.init();
    },
    icChanged() {
      localStorage.demo_selectedItemCategory = JSON.stringify(this.selectedItemCategory);
      this.getProductsList();
      // this.init();
    },
    init() {
      // this.nonPrimaryProductsOptions = [];
      this.primaryProductsOptions = [];
      this.products = [];
      this.selectedProducts = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let ci = 0;
      this.primaryProductsOptions[0] = this.allProducts
      this.primaryProductsOptions[1] = this.allProducts
      this.primaryProductsOptions[2] = this.allProducts
      // for (let [i, k] of this.productList.entries()) {
      //   console.log("checking product list")
      //   let obj = {
      //     brand: "test",
      //     color: color[ci],
      //     forum: false,
      //     primary: k.primary,
      //     product_name: k.name,
      //   };
      //   if (k.primary) this.primaryProductsOptions.push(obj);
      //   else this.nonPrimaryProductsOptions.push(obj);
      //   if (ci == color.length - 1) ci = 0;
      //   else ci++;
      // }
      this.products = [
        this.primaryProductsOptions[0],
        this.primaryProductsOptions[1],
        this.primaryProductsOptions[2],
        // this.nonPrimaryProductsOptions[0],
        // this.nonPrimaryProductsOptions[1],
      ];
      this.selectedProducts = [
        this.primaryProductsOptions[0][0].options[0],
        this.primaryProductsOptions[1][1].options[0],
        this.primaryProductsOptions[2][2].options[0],
        // this.nonPrimaryProductsOptions[0].product_name,
        // this.nonPrimaryProductsOptions[1].product_name,
      ];
      this.selectedBrand[0] = this.primaryProductsOptions[0][0].optgroup
      this.selectedBrand[1] = this.primaryProductsOptions[1][1].optgroup
      this.selectedBrand[2] = this.primaryProductsOptions[2][2].optgroup
      this.refresh();
    },
    createPdf() {
      let self = this;
      self.loader = true;
      let content = document.querySelector("#dashboardPdf");
      let canvasWidth = content.scrollWidth + 5;
      let canvasHeight = content.scrollHeight + 5;
      let options = {
        scale: 1.5,
        width: canvasWidth,
        onclone: function () {
          alert("Pdf generated. Download Now");
        },
      };
      setTimeout(function () {
        html2canvas(content, options).then((canvas) => {
          let imgData = canvas.toDataURL("image/jpeg", 1.0);
          let doc = new jsPDF("p", "mm", [canvasWidth, canvasHeight]);
          let pdfWidth = canvasWidth - 16;
          let pdfHeight = canvasHeight;
          doc.addImage(imgData, "JPEG", 8, 8, pdfWidth, pdfHeight);
          doc.save("voc_weavr_dashboard_" + moment().format("DDMMMYYYY") + ".pdf");
          self.loader = false;
        });
      }, 0);
    },

    changeProduct(ud, idx, event) {
      let self = this;
      // if (idx == 0) {
      //   let isPrimary = false;
      //   // let compData =
      //   //   self.competitorData[this.channelSelector][this.selectedItemCategory.key][
      //   //   self.selectedProducts[0]
      //   //   ];
      //   for (let [ci, cdata] of this.productList[this.channelSelector][
      //     this.selectedItemCategory.key
      //   ].entries()) {
      //     if (self.selectedProducts[0] == cdata.name) {
      //       if (cdata.primary) isPrimary = true;
      //     }
      //   }
      //   if (isPrimary) {

      //     self.selectedProducts[1] = compData.comp1;
      //     self.selectedProducts[2] = compData.comp2;
      //   }
      // }


      // Setting the selected brand
      const index = event.target.selectedIndex;
      const option = event.target.options[index];
      const optgroup = option.parentElement;
      const selectedLabel = optgroup.getAttribute('label');

      this.selectedBrand[idx] = selectedLabel;

      // self.products = [];
      let color = ["#0072ba", "#f56628", "#f3b821"];
      let cci = 0;
      // for (let [pi, pdata] of this.selectedProducts.entries()) {
      //   for (let [ci, cdata] of this.productList[this.channelSelector][
      //     this.selectedItemCategory.key
      //   ].entries()) {
      //     if (pdata == cdata.name) {
      //       let obj = {
      //         brand: "test",
      //         color: color[cci],
      //         forum: false,
      //         primary: cdata.primary,
      //         product_name: cdata.name,
      //       };
      //       self.products.push(obj);
      //       if (cci == color.length - 1) cci = 0;
      //       else cci++;
      //     }
      //   }
      // }
      self.refresh();
    },
    getProductRecentRating() {
      let self = this;
      for (let [i, k] of this.selectedProducts.entries()) {
        self.loader3 = true;
        const url = "api/global_demo/get_product_recent_rating";
        let payload = {
          channel: this.channelSelector,
          start_date: this.date.startDate,
          end_date: this.date.endDate,
          item_category: this.selectedItemCategory.key,
          client: self.customClient,
          product_name: k,
        };
        this.$http.post(url, payload).then(
          (response) => {
            this.recentRating[k] = response.data.data;
            self.loader3 = false;
          },
          (err) => {
            self.loader3 = false;
          }
        );
      }
    },
    drawStackChart() {
      let self = this;
      let dataNeutral = [];
      let dataPositive = [];
      let dataNegative = [];
      let category = [];
      // for (let brand of this.selectedBrand) {
        for (let [i, k] of this.data.entries()) {
          // if (brand === k.brand_name) {
            let seriesName = "";

            if (!k.product_name) {
              seriesName = `${k.brand_name.toUpperCase()} - All Products`
            } else seriesName = k.product_name.toUpperCase()

            category.push(seriesName);

            dataNeutral.push(k.rating_sentiment["neutral"].count);
            dataPositive.push(k.rating_sentiment["positive"].count);
            dataNegative.push(k.rating_sentiment["negative"].count);
          }
        // }
      // }
      this.charts.stackgraph = {
        chart: {
          type: "column",
          height: 300,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: category,
        },
        yAxis: {
          min: 0,
          max: 100,
          tickInterval: 10,
          title: {
            text: "",
          },
          stackLabels: {
            enabled: false,
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = this.point.category + "<br/>";
            mytooltip +=
              '<span style="color:' + this.point.series.color + '">\u25CF</span> ';
            mytooltip += this.point.series.name;
            mytooltip +=
              " : <b> " +
              self.format(this.point.y) +
              " (" +
              self.format(this.point.percentage) +
              "%)</b> <br/>";
            mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
            return mytooltip;
          },
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          column: {
            stacking: "percent",
            borderWidth: 0,
            dataLabels: {
              enabled: false,
            },
          },
        },
        series: [
          {
            name: "Neutral",
            data: dataNeutral,
            color: "#B3B2B9",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Positive",
            data: dataPositive,
            color: "#1ACF85",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
          {
            name: "Negative",
            data: dataNegative,
            color: "#FF786B",
            marker: {
              states: {
                hover: {
                  radiusPlus: 5,
                  lineWidthPlus: 3,
                },
              },
            },
          },
        ],
      };
    },
    drawCircularChart() {
      let self = this;
      let series = [];
      let color_codes = [
        "#88aec1",
        "#ffd0c5",
        "#eea39f",
        "#79A69E",
        "#317367",
        "#54736D",
        "#52BFAB",
        "#84B5AC",
        "#5F827C",
        "#388273",
        "#59CFB7",
      ];

      // for (let brand of this.selectedBrand) {
        for (let [i, k] of this.data.entries()) {
          // if (brand === k.brand_name) {
            let seriesName;
            if (!k.product_name) {
              seriesName = `${k.brand_name.toUpperCase()} - All Products`
            } else seriesName = k.product_name.toUpperCase();

            let data = {};
            data.name = seriesName;
            data.y = k.count;
            // data.color = dataset.color
            series.push(data);
          // }
        // }
      }
      this.charts.circlular = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin: [0, 0, 0, 0],
          padding: [0, 0, 0, 0],
          height: 300,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            var mytooltip = "";
            mytooltip +=
              '<span style="color:' + this.point.series.color + '">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip +=
              " : <b> " +
              self.format(this.point.y) +
              " (" +
              self.format(this.point.percentage) +
              "%)</b> <br/>";
            mytooltip += "Total: <b>" + self.format(this.point.total) + "</b>";
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            borderWidth: 0,
          },
          pie: {
            dataLabels: {
              enabled: true,
              distance: -15,
              format: "{point.percentage:.1f} %",
              style: {
                fontSize: 10,
              },
            },
            showInLegend: true,
            startAngle: -180,
            endAngle: 180,
            center: ["50%", "37%"],
            size: "74%",
            colors: color_codes,
          },
        },
        legend: {
          itemStyle: {
            fontSize: 9,
          },
        },
        series: [
          {
            type: "pie",
            innerSize: "50%",
            data: series,
          },
        ],
      };
    },
    format(v) {
      return this.$options.filters.format(v);
    },

    refresh() {
      this.date = this.$refs.datecomponent.date;
      // this.getProductRecentRating();
      this.getData();
      this.getChartData();
    },
    getData() {
      let self = this;
      self.loader1 = true;
      this.data = [];
      const url = "/api/global_demo/reviews/bulk";
      let payload = {
        channel: this.channelSelector,
        start_date: this.date.startDate,
        end_date: this.date.endDate,
        item_category: this.selectedItemCategory.key,
        brand_prod_list: [
          {
            brand_name: this.selectedBrand[0]
          },
          {
            brand_name: this.selectedBrand[1]
          },
          {
            brand_name: this.selectedBrand[2]
          }
        ]
      }

      this.selectedProducts.forEach((product, index) => {
        if(product !== 'All') {
          payload.brand_prod_list[index] = Object.assign(payload.brand_prod_list[index], {product_name: product})
        }
      })

      this.$http.post(url, payload).then(
        (response) => {
          this.data = response.body.data;
          self.loader1 = false;
          this.createReviewCountMapper();
          this.drawCircularChart();
          this.drawStackChart();
        },
        (err) => {
          self.loader1 = false;
        }
      );
    },
    createReviewCountMapper() {
      this.reviewCountMapper = [];
      this.ratingMapper = [];
      for (let brand of this.selectedBrand) {
        for (let [idx, dataset] of this.data.entries()) {
          if (brand === dataset.brand_name) {
            if (dataset.product_name) {
              this.reviewCountMapper[idx] = {
                [dataset.product_name]: dataset.count
              }
              this.ratingMapper[idx] = {
                [dataset.product_name]: dataset
              }
            } else {
              this.reviewCountMapper[idx] = {
                All: dataset.count
              }
              this.ratingMapper[idx] = {
                All: dataset
              }
            }
          }
        }
      }
    },
    plotChart(d) {
      var self = this;
      let tickInterval;

      if (this.selected === 'month') {
        tickInterval = 5
      } else if (this.selected === 'week') {
        tickInterval = 10
      } else tickInterval = 50;

      this.charts[d.key] = {
        credits: {
          enabled: false,
        },
        chart: {},
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },

        yAxis: {
          title: {
            text: "",
          },
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          tickInterval: tickInterval,
          tickWidth: 2,
          margin: 25,
          crosshair: {
            width: 70,
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y) + "</b> <br/>";
            }
            return mytooltip;
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 3,
              states: {
                hover: {
                  radiusPlus: 4,
                  lineWidthPlus: 2,
                },
              },
            },
          },
        },
        series: d.series,
      };
    },
    processChartData(data, key) {
      let category = [];
      let series = [];
      let color_codes = ["#009688", "#FFAB00", "#DE7DEB"];
      
      // for(let brand of this.selectedBrand) {
        for (let [i, k] of data.entries()) {
          // if(brand === k.brand_name) {
            let seriesName = "";
    
            if (!k.product_name) {
              seriesName = `${k.brand_name.toUpperCase()} - All Products`
            } else if(k.product_name === this.selectedProducts[i]) seriesName = k.product_name.toUpperCase()
            
            let obj = {};
            obj.name = seriesName;
            obj.data = [];
            obj.color = color_codes[i];
            for (let [j, x] of k.timeline.entries()) {
              obj.data.push(x[key]);
              if (i == 0) {
                if (this.selected === 'month') {
                  let monthYear = moment(x.date).format("MMM-YYYY");
                  category.push(monthYear);
                } else if (this.selected === 'week') {
                  let weekDate = moment(x.date).format("DD-MMM-YY");
                  category.push(weekDate);
                } else {
                  category.push(x["date"]);
                }
              }
            }
            series.push(obj);
          }
        // }
      // }
      this.plotChart({ key: key, series: series, category: category });
    },
    getChartData() {
      let self = this;
      self.loader2 = true;
      this.activeChart = false;
      const url =
        "/api/global_demo/reviews/histogram";

      let payload = {
        channel: this.channelSelector,
        start_date: this.date.startDate,
        end_date: this.date.endDate,
        interval: this.selected,
        client: "global_demo",
        item_category: this.selectedItemCategory.key,
        brand_prod_list: [
          {
            brand_name: this.selectedBrand[0]
          },
          {
            brand_name: this.selectedBrand[1]
          },
          {
            brand_name: this.selectedBrand[2]
          }
        ]
      }

      this.selectedProducts.forEach((product, index) => {
        if(product !== 'All') {
          payload.brand_prod_list[index] = Object.assign(payload.brand_prod_list[index], {product_name: product})
        }
      })

      this.$http.post(url, payload).then(
        (response) => {
          let gKeys = Object.keys(response.body.data[0].timeline[0]);
          for (let [idx, key] of gKeys.entries()) {
            if (key != "date") {
              this.charts[key] = {};
              this.processChartData(response.body.data, key);
            }
          }
          this.activeChart = true;
          self.loader2 = false;
        },
        (err) => {
          self.loader2 = false;
        }
      );
    },
  },
};
</script>

<style scoped>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.card_vivo {
  background-color: #0072ba !important;
  border: 1px solid #0072ba !important;
}

.card_realme {
  background-color: #f3b821 !important;
  border: 1px solid #f3b821 !important;
}

.card_redmi {
  background-color: #f56628 !important;
  border: 1px solid #f56628 !important;
}

.datebox {
  width: 12% !important;
}

.recent-rating {
  padding: 2px 7px;
  border-radius: 14px;
  font-size: 14px;
  background-color: #1d1d1d3b;
  vertical-align: baseline;
  line-height: normal;
  display: inline-block;
  color: #fff;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 1rem;
  padding-bottom: 5px;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}

.positive-head {
  padding: 15px;
  background: var(--primary_client-20);
  color: var(--primary_brand);
  margin-top: -5px !important;
  border-radius: 0.5rem;
  font-weight: 600;
}

.separated-card:not(:last-child) {
  margin-right: 14px;
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show>.btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}

.datePickerBadge {
  margin-left: 6px;
  height: 35px !important;
  border: 1px solid #c5c5c5;
  border-right: none;
  display: flex;
  align-items: center;
  margin-right: -5px;
  z-index: 3;
  background: #fff;
  color: black;
  border-radius: 5px 0px 0px 5px;
  font-family: "poppins";
}

.card-title {
  color: var(--primary_brand);
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
  font-size: 20px !important;
}

/* .submit{
  width: 11%;
   position: relative; 
   right: calc(9vw)
} */
</style>
